module.exports = __webpack_public_path__ + "img/DW365-267.4afd9739.jpg";